var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloppyDiskLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.951,
    height: 10.951,
    viewBox: "0 0 10.951 10.951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "floppy-disk-light",
    d: "M.782,33.564a.781.781,0,0,1,.782-.782v2.347a.781.781,0,0,0,.782.782H7.04a.781.781,0,0,0,.782-.782v-2.3a.8.8,0,0,1,.3.186l1.821,1.821a.781.781,0,0,1,.23.552v6a.781.781,0,0,1-.782.782H1.564a.781.781,0,0,1-.782-.782Zm1.564-.782H7.04v2.347H2.347ZM0,33.564v7.822a1.566,1.566,0,0,0,1.564,1.564H9.386a1.566,1.566,0,0,0,1.564-1.564v-6a1.565,1.565,0,0,0-.457-1.107L8.67,32.457A1.565,1.565,0,0,0,7.563,32h-6A1.566,1.566,0,0,0,0,33.564ZM6.649,39.04a1.173,1.173,0,1,1-1.173-1.173A1.173,1.173,0,0,1,6.649,39.04ZM5.475,37.084A1.955,1.955,0,1,0,7.431,39.04,1.955,1.955,0,0,0,5.475,37.084Z",
    transform: "translate(0 -32)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloppyDiskLight);
export default __webpack_public_path__ + "static/media/floppy-disk-light.a5c57c4dc88171f8f55cc59e6fcd19e4.svg";
export { ForwardRef as ReactComponent };